module.exports = __webpack_public_path__ + "static/media/dashboard-pallet-home-image.1f80ea2b.webp";